class HistorySlider {
	static init() {

        var sliderAdaptiveHeight = function(next) {
            var heights = [];
            // let items = $('.slick-active[data-slick-index='+next+']');
            // items.each(function() {
            //     heights.push($(this).height());
            // });
            for (var i = 0; i < 4; i++) {
                var slide = next+i;
                console.log(slide);
                heights.push($('#history-slider .slick-slide[data-slick-index="'+slide+'"]').height());
            }
            $('#history-slider .slick-list').height(Math.max.apply(null, heights)+40);
            $('#history-slider .slick-slide').height(Math.max.apply(null, heights));
            // $('.slick-track').height(Math.max.apply(null, heights)+50);
        }

        $('#history-slider').on('init', function(){
            var heights = [];
            let items = $('.slick-active')
            items.each(function() {
                heights.push($(this).height());
            });
            $('#history-slider .slick-list').height(Math.max.apply(null, heights));
            $('#history-slider .slick-active').height(Math.max.apply(null, heights));
        });

        $('#history-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            sliderAdaptiveHeight(nextSlide);
        });
        $('#history-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
            var decade = $('#history-slider .slick-current').data('decade');
            $('#history-slider .slick-slide:not(.slick-active)').css('height','');
            $('.decade-tab').removeClass('active');
            $('.decade-tab[data-decade="'+decade+'"]').addClass('active');
        });
        var historySlider = $('#history-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            rows: 0,
            // slidesPerRow: 4,
            prevArrow:'<a class="slick-prev"><i class="fal fa-angle-left"></i></a>',
            nextArrow:'<a class="slick-next"><i class="fal fa-angle-right"></i></a>',
            adaptiveHeight:true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 740,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        $(document).on('click', '.history-nav', function() {
            var width = $('body').width();
            var currentSlide = historySlider.slick('slickCurrentSlide');
            if ($(this).hasClass('slick-prev')) {
                switch (true) {
                    case width <= 740:
                        historySlider.slick('slickGoTo', currentSlide-1);
                        break;
                    case width <= 1024:
                        historySlider.slick('slickGoTo', currentSlide-3);
                        break;
                    default:
                        historySlider.slick('slickGoTo', currentSlide-4);
                }
            } else {
                switch (true) {
                    case width <= 740:
                        historySlider.slick('slickGoTo', currentSlide+1);
                        break;
                    case width <= 1024:
                        historySlider.slick('slickGoTo', currentSlide+3);
                        break;
                    default:
                        historySlider.slick('slickGoTo', currentSlide+4);
                }
            }
        });

        $(document).on('click', '.decade-tab', function() {
            $('.decade-tab').removeClass('active');
            $(this).addClass('active');
            var decadeID = $(this).data('decade');
            var slide = $('.decade-'+decadeID).first().data('index');
            var lastSlide = $('.history-item.last').data('index');

            if ($(this).hasClass('last')) {
                historySlider.slick('slickGoTo', lastSlide-1);
            } else {
                historySlider.slick('slickGoTo', slide-1);
            }

        });
    }
}
